<template>
    <v-row v-if="!$store.getters.progress" style="pb-offset pt-4">
		<v-col class="pa-0 px-4 pt-2 col-12">
            <v-card class="flex pa-0 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Scheduling Mail automatiche</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-container class="pt-0" fluid>
                    <v-row class="pb-3">
                        <v-col class="pa-0 px-4 pt-4" cols="12" lg="6">
                            <v-text-field
                                label="Nome*"
                                v-model="model['name']"
                                required
                                :error-messages="errors.collect('Nome')"
                                v-validate="'required'"
                                :data-vv-name="'Nome'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pa-0 px-4 pt-4" cols="12" lg="6">
                            <v-text-field
                                label="Dopo*"
                                v-model="model['day_after']"
                                required
                                :error-messages="errors.collect('Dopo')"
                                v-validate="'required'"
                                :data-vv-name="'Dopo'"
                                outlined
                                dense                                
                            ></v-text-field>
                        </v-col>
                        <v-col class="pa-0 px-4" cols="12" lg="6">
                            <v-combobox
                                name="from"
                                label="Da"
                                small-chips
                                combobox
                                clearable
                                required
                                v-model="model['from']"
                                :error-messages="errors.collect('Da')"
                                v-validate="'email|required'"
                                :data-vv-name="'Da'"
                                outlined
                                dense                                
                            ></v-combobox>
                        </v-col>
                        <v-col class="pa-0 px-4" cols="12" lg="6">
                            <v-combobox
                                label="Nome Mittente"
                                small-chips
                                combobox                                
                                clearable
                                v-model="model['from_name']"
                                color="primary"
                                outlined
                                dense>
                            </v-combobox>
                        </v-col>
                        <v-col class="pa-0 px-4" cols="12">
                            <v-combobox
                                name="cc"
                                label="Cc"
                                :items="info.cc"
                                small-chips
                                combobox
                                clearable
                                multiple
                                v-model="model['cc']"
                                :error-messages="errors.collect('Cc')"
                                v-validate="'email'"
                                :data-vv-name="'Cc'"
                                outlined
                                dense
                            ></v-combobox>
                        </v-col>
                        <v-col class="pa-0 px-4" cols="12">
                            <v-combobox
                                name="ccn"
                                label="Ccn"
                                :items="info.ccn"
                                small-chips
                                combobox
                                clearable
                                multiple
                                v-model="model['ccn']"
                                :error-messages="errors.collect('Ccn')"
                                v-validate="'email'"
                                :data-vv-name="'Ccn'"
                                outlined
                                dense                                
                            ></v-combobox>
                        </v-col>
                        <v-col class="pa-0 px-4" cols="12" lg="6">
                            <v-text-field
                                label="Oggetto"
                                v-model="model['subject']"
                                type="text"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pa-0 px-4" cols="12" lg="6">
                            <v-text-field
                                label="Sconto aggiuntivo"
                                hint="Questo sconto sarà aggiunto, se presente, allo sconto globale del preventivo"
                                v-model="model['global_discount']"
                                suffix="%"
                                type="number"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pa-0 px-4" cols="6" >
                            <v-select
                                :items="info.template_mail"
                                label="Template Mail"
                                hint="Seleziona il template da inserite nella mail"
                                :required="false"
                                v-model="model['template_mail_id']"
                                return-object
                                outlined
                                dense                                
                                @change="setTemplateInTextEditor($event)">
                            </v-select>
                        </v-col>                            
                        <v-col class="pa-0 px-4" cols="6">
                            <v-select
                                :items="signatures"
                                label="Firma"
                                hint="Seleziona una firma da inserite nella mail"
                                :required="false"
                                v-model="signatureSelected"
                                return-object
                                outlined
                                dense>
                            </v-select>
                        </v-col>
                        <v-col class="px-4 d-block text-center" cols="12">
                            <v-switch
                                inset
                                class="text-center"
                                label="Includi mail precedenti"
                                v-model="model['previous_mail']"
                                :input-value="[true,false]"
                                color="primary"
                                outlined
                            ></v-switch>
                        </v-col>
                        <v-col class="px-4 d-block" cols="12">
                            <v-subheader class="pl-1 pt-2">Corpo</v-subheader>
                            <vue-editor 
                                id="mail-text"
                                v-model="model['body']"
                                ref='editor'
                            ></vue-editor>
                        </v-col>

                        <v-col class="px-4 d-block text-center" cols="12">
                            <template v-if="info.email_variables" >
                                <v-chip v-for="(value, key, i) in info.email_variables.variables" outlined color="primary" text-color="primary" @click="setTemplateVariable(value)" :key="i">
                                    {{ value }}
                                    <v-icon right>mdi-content-copy</v-icon>
                                    </v-chip>
                            </template>
                        </v-col>

                    </v-row>
                    <small class="pa-0 px-4 pt-4">* Indica i campi obbligatori</small>
                </v-container>
            </v-card>
        </v-col>
        <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
                <v-fab-transition>
                    <v-btn
                        v-on="{ ...tooltip }"
                        @click.native="updateModel"
                        :loading="saved"
                        color="primary"
                        dark
                        fixed
                        bottom
                        right
                        fab>
                        <v-icon>check</v-icon>
                    </v-btn>
                </v-fab-transition>
            </template>
            <span>Salva</span>
        </v-tooltip>
		<confirm-dialog
			:confirmModel="confirmExit"
			:mainTitle="$trans('save_primary_message')"
			:secondTitle="$trans('save_secondary_message')"
			@update:confirmModel="confirmExit = false"
            :exit="{label:'Esci', color:'error'}"
			:atConfirm="updateModel"
			:atExit="exit"
		></confirm-dialog>        
    </v-row>
</template>

<script>

	import MailTemplateMixin from '@/mixins/MailTemplateMixin'

    export default {
        name: 'edit-quotationchedule',
		mixins: [MailTemplateMixin],
        props: {
            id: Number,
            redirect: Object,
            urlAppend: {
                type: String,
                default: ''
            },
        },

        data() {
            return {
                model: {},
                info: {},
                showCc: false,
                showCcn: false,
                signatures: [],
                signatureSelected: {},
                saved: false,
                modelDef: 'quotationsmailsschedules',
                changed: false,
                confirmExit: false,
                next: null
            }
        },

        beforeRouteLeave(to, from, next) {
            if(this.$store.getters.modelEdited) {
                this.confirmExit = true
                this.next = next
            } else {
                next()
            }
        },
        
        created() {
            this.axios.get(this.modelDef + '/' +this.id + '/edit').then(response => {
                // get body data
                this.info = response.data.data.info
                this.model = response.data.data.model

                this.signatures = this.info.signatures
                this.signatureSelected = _.find(this.signatures, (s) => this.model.signature_id == s.value)
                this.cc = this.info.cc
                this.ccn = this.info.ccn
                this.$store.commit('endProgress')

            }, response => {
                    // error callback
            })
        },

        beforeDestroy() {
            this.$store.commit('setModelEdited', false)
	    },


        methods: {
            
            updateModel() {
                this.confirmExit = false
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }

                    this.saved = true
                    this.model.signature_id = this.signatureSelected.value
                    this.model.template_mail_id = this.model.template_mail_id.value

                    this.axios.put(this.modelDef + '/' + this.model.id, this.model).then(response => {
                        // get body data
                        this.saved = false
                        //this.model = {}
                        this.$store.commit('setModelEdited', false)
                        // Got in show
                        if(this.next != null) {
                            this.next()
                        } else {
                            this.$router.push({ name: 'settingsquotationsscheduling'})
                        }
                    }, response => {
                        // error callback
                    })
                }).catch(() => {
                    
                })
            },
        },
    }
</script>
